"use strict";

export function scaleSprite(scale, spriteSize) {
	return ~~(scale*spriteSize);
}

export function colorIndex(r, g, b) {
	return (r >> 4 << 8) + (g >> 4 << 4) + (b >> 4);
}




//////////////////
// WEBPACK FOOTER
// ./src/scripts/draw/sprites/util.js
// module id = 5
// module chunks = 0